var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[(_vm.genders.length > 0)?_c('v-chart',{attrs:{"chart-type":"doughnut","data-sets":_vm.dataSets,"labels":_vm.labels,"size":"sm","download-enabled":false,"show-legend":false}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }